// extracted by mini-css-extract-plugin
export default {"resetPassword":"reset-password_resetPassword__J2dZu","userForm":"reset-password_userForm__W89nk","buttons":"reset-password_buttons__V9dqn"};